import { requestCDN, requestWin } from "../../apis";
import localStorageKey from "../../enumerations/localStorageKey";

const CURRENCY =
  window.localStorage.getItem(localStorageKey.DEFAULT_CURRENCY) ||
  process.env.REACT_APP_DEFAULT_CURRENCY;

export const apiPostGameBet = (params) => requestWin("post", `/${CURRENCY}/game/bet`, params, true);

export const getGameWay = ({ params }) =>
  requestWin("get", `/${CURRENCY}/game/way/${params.game_way}`, params, true);

export const getGameMethod = ({ params }) => {
  const millis = Date.now();
  return requestCDN(
    "get",
    `/winlottery/GameWayList/${CURRENCY?.toUpperCase()}_${params.game_way_type}.json?v=${millis}`,
  );
  // return requestWin("get", `/${CURRENCY}/game/way/method/${params.game_way_type}`, params, false);
};

export const getGameRecord = ({ params }) => {
  const millis = Date.now();
  return requestCDN("get", `/winlottery/GameBetHistory/${params.game_type}.json?v=${millis}`);
  // return requestHistory("get", `/${CURRENCY}/game/record`, params, false);
};

export const getGameRule = ({ params }) =>
  requestWin("get", `/${CURRENCY}/game/rule`, params, true);

export const getLatestNumber = ({ params }) => {
  // if (WIN_FROM_JSON) {
  //   const millis = Date.now();
  //   return requestCDN("get", `/winlottery/GamePeriod/${params.game_way}.json?v=${millis}`);
  // }
  return requestWin("get", `/${CURRENCY}/game/way/${params.game_way}/period`, params, false);
};

export const getWinCategory = (params) => {
  const millis = Date.now();
  return requestCDN("get", `/winlottery/CategoryList/LOT.json?v=${millis}`);
  // return requestWin("get", `/${CURRENCY}/game/category/LOT`, params, false);
};
